import { Button, cn } from "@tellescope/design-system";
import { Flag } from "lucide-react";
import { useTranslation } from "react-i18next";

export interface FlaggedNoteOverlayProps {
  note: string;
  onAcknowledge: () => void;
  className?: string;
}

// TODO: replace this hand-rolled overlay with the design-system Dialog once that component supports a
// contained variant. It is hand-rolled because the overlay must be scoped to the contact details
// sidebar, not the viewport: `Dialog` (@tellescope/ui) hardcodes `fixed inset-0` on the overlay and
// `fixed top-1/2 left-1/2` on the content, so it blankets the whole screen even when portaled into a
// scoped container. See the matching TODO in
// packages/components/ui/src/components/Dialog/DialogContent.tsx for the changes needed there.
export const FlaggedNoteOverlay = ({ note, onAcknowledge, className }: FlaggedNoteOverlayProps) => {
  const { t } = useTranslation("contacts");

  return (
    <div
      role="alertdialog"
      aria-modal="true"
      aria-label={t("Flagged note")}
      className={cn("absolute inset-0 flex items-center justify-center bg-background/80 backdrop-blur-sm", className)}
    >
      <div className="m-4 flex max-h-full flex-col gap-3 overflow-y-auto rounded-lg border border-yellow-500 bg-background p-4 shadow-lg">
        <span className="flex items-center gap-2 text-sm font-medium text-yellow-700 dark:text-yellow-500">
          <Flag className="size-4 fill-current" />
          {t("Flagged note")}
        </span>
        <p className="text-xs text-muted-foreground">
          {t("This contact has a flagged note. Please review it before continuing.")}
        </p>
        <p className="whitespace-pre-wrap text-sm font-light">{note}</p>
        <Button className="self-end" onClick={onAcknowledge} size="sm">
          {t("Acknowledge")}
        </Button>
      </div>
    </div>
  );
};
